<template>
    <v-app id="inspire">
      <Header type="return"/>
      <v-main class="grey lighten-3">
        <v-container>
          <v-row>
            <Menu/>
            <v-container class="col-10">
              <v-row>
                <v-col
                    class="page-top d-flex justify-space-between"
                    cols="12"
                >
                  <div>
                    <div class="page-title">Продажа</div>
                    <div class="breadcrumb"><span class="breadcrumb-bold">Ресепшен / Рабочий стол / Продажа /</span>
                      История
                    </div>
                  </div>
                </v-col>
                <v-col cols="12">
                  <v-sheet
                      max-height="80px"
                      rounded="lg"
                      class="d-flex justify-space-between align-center card"
                  >
                    <div>
                      {{ client.name }}
                    </div>
                  </v-sheet>
                </v-col>
                <v-col cols="12">
  
                  <v-data-table
                    v-if="saleHistory && saleHistory.sales && saleHistory.sales.length > 0"
                    :headers="headersHistory"
                    :items="saleHistory.sales"
                    hide-default-footer
                  >
                  <template v-slot:item.date="{ item }">
                          {{ item.date }} {{ item.time }}
                      </template>
     
                      <template v-slot:item.comment="{ item }">
                          {{ item.comment }}
                      </template>
                  </v-data-table>
                  <v-data-table
                      v-else-if="saleInfo && saleInfo.sales"
                      :headers="headersHistoryNoPays"
                      :items="(saleInfo && saleInfo.sales && saleInfo.sales.buy_list) ? saleInfo.sales.buy_list : []"
                      hide-default-footer
                    >
                    <template v-slot:item.count>
                            {{ saleInfo.sales.date }}
                        </template>
                        <template v-slot:item.price>
                            {{ saleInfo.sales.user.name }}
                        </template>
                        <template v-slot:item.service="{ item }">
                            {{ item.service.name }}
                        </template>
                  </v-data-table>
                </v-col>
              </v-row>
            </v-container>
          </v-row>
          <v-row justify="center">
            <v-dialog
                v-model="dialogClient"
                persistent
                max-width="700px"
            >
              <v-card rounded="lg">
                <v-card-title class="justify-space-between">
                  <div></div>
                  <div>
                    <h4>Новый клиент</h4>
                  </div>
                  <v-btn icon @click="dialogClient = false" >
                    <v-icon>mdi-close-circle-outline</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-container>
                    <v-form ref="form" @submit.prevent="submit">
                      <v-row>
                        <v-col
                            cols="12"
                            sm="6"
                            md="4"
                        >
                          <label>Фамилия <span style="color: #D53025">*</span></label>
                          <v-text-field
                              v-model="middle_name"
                              :rules="middleNameRules"
                              label="Фамилия"
                              class="rounded-lg"
                              outlined
                              dense
                              style="height: 30px;margin-top: 10px"
                          ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="6"
                            md="4"
                        >
                          <label>Имя <span style="color: #D53025">*</span></label>
                          <v-text-field
                              v-model="first_name"
                              :rules="firstNameRules"
                              label="Имя"
                              class="rounded-lg"
                              outlined
                              dense
                              style="height: 30px;margin-top: 10px"
                          ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="6"
                            md="4"
                        >
                          <label>Отчество <span style="color: #D53025">*</span></label>
                          <v-text-field
                              v-model="last_name"
                              :rules="lastNameRules"
                              label="Отчество"
                              class="rounded-lg"
                              outlined
                              dense
                              style="height: 30px;margin-top: 10px"
                          ></v-text-field>
                        </v-col>
                      </v-row>
                      <v-row class="mt-5">
                        <v-col
                            cols="12"
                            sm="6"
                            md="4"
                        >
                          <label>Телефон <span style="color: #D53025">*</span></label>
                          <v-text-field
                              v-model="phone"
                              :rules="phoneRules"
                              v-mask="'+7 (###) ###-##-###'"
                              label="Телефон"
                              class="rounded-lg"
                              outlined
                              dense
                              style="height: 30px;margin-top: 10px"
                          ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="6"
                            md="4"
                        >
                          <label>Электронная почта <span style="color: #D53025">*</span></label>
                          <v-text-field
                              v-model="email"
                              :rules="emailRules"
                              label="Электронная почта"
                              class="rounded-lg"
                              outlined
                              dense
                              style="height: 30px;margin-top: 10px"
                          ></v-text-field>
                        </v-col>
                        <v-col
                            cols="12"
                            sm="6"
                            md="4"
                        >
                          <label>Пол <span style="color: #D53025">*</span></label>
                          <v-select
                              :items="['Мужской', 'Женский']"
                              v-model="sex"
                              :rules="sexRules"
                              label="Пол"
                              class="rounded-lg"
                              outlined
                              dense
                              style="height: 30px;margin-top: 10px"
                          ></v-select>
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-card-actions style="padding: 30px 10px !important;">
                          <button
                              class="button button__success"
                              ref="activator"
                              type="submit"
                          >
                            Сохранить
                          </button>
                        </v-card-actions>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-dialog>
          </v-row>
        </v-container>
      </v-main>
    </v-app>
  </template>
  
  <script>
  import Header from "@/components/Header";
  import Menu from "@/components/Menu";
  import {mapState} from "vuex";
  import {receptionActionTypes} from "@/store/modules/reception";
  import {clientActionTypes} from "@/store/modules/client";
  import {getItem, setItem} from "../helpers/persistanceStorage";
  import {salesActionTypes} from "@/store/modules/sale";
  
  export default {
    name: "SaleHistory",
    props: ['client','buy_id'],
    components: {
      Header,
      Menu
    },
    data() {
      return {
        valid: true,
        first_name: '',
        firstNameRules: [
          v => !!v || 'Имя обязательное поле'
        ],
        middle_name: '',
        middleNameRules: [
          v => !!v || 'Фамилия обязательное поле'
        ],
        last_name: '',
        lastNameRules: [
          v => !!v || 'Отчество обязательное поле'
        ],
        sex: '',
        sexRules: [
          v => !!v || 'Пол обязательное поле'
        ],
        email: '',
        emailRules: [
          v => !!v || 'Электронная почта обязательное поле',
          v => /.+@.+\..+/.test(v) || 'Электронная почта не правильно заполнена',
        ],
        phone: '',
        phoneRules: [
          v => !!v || 'Телефон обязательное поле'
        ],
        select: {
          client_id: getItem('sale-client_id')
        },
        searchClient: '',
        dialogClient: false,
        headersHistory: [
          {text: 'Дата', sortable: false, value: 'date'},
          {text: 'Сотрудник', sortable: false, value: 'user.name'},
          {text: 'История', sortable: false, value: 'comment'},
        ],
        headersHistoryNoPays: [
          {text: 'Дата', sortable: false, value: 'count'},
          {text: 'Сотрудник', sortable: false, value: 'price'},
          {text: 'История', sortable: false, value: 'service.name'},
        ],
        history: [
          {date: '25.25.2999', employee: 'Иванов Иван Иванович', history: 'Тестовая фраза для заполнения'},
          {date: '25.25.2999', employee: 'Иванов Иван Иванович', history: 'Тестовая фраза для заполнения'},
          {date: '25.25.2999', employee: 'Иванов Иван Иванович', history: 'Тестовая фраза для заполнения'},
          {date: '25.25.2999', employee: 'Иванов Иван Иванович', history: 'Тестовая фраза для заполнения'},
          {date: '25.25.2999', employee: 'Иванов Иван Иванович', history: 'Тестовая фраза для заполнения'},
          {date: '25.25.2999', employee: 'Иванов Иван Иванович', history: 'Тестовая фраза для заполнения'},
          {date: '25.25.2999', employee: 'Иванов Иван Иванович', history: 'Тестовая фраза для заполнения'},
          {date: '25.25.2999', employee: 'Иванов Иван Иванович', history: 'Тестовая фраза для заполнения'},
        ]
      }
    },
    methods: {
      fetchFeed(buy_id) {
        this.$store.dispatch(salesActionTypes.getSaleInfo, {buy_id});
        console.log('asasaass')
        this.$store.dispatch(salesActionTypes.saleHistory, {buy_id});
        console.log('b1111')
      },
      submit() {
        if (this.$refs.form.validate()) {
          this.$store.dispatch(clientActionTypes.createClient, {
            from: 'reception',
            last_name: this.last_name,
            first_name: this.first_name,
            middle_name: this.middle_name,
            phone: this.phone,
            email: this.email,
            sex: this.sex
          })
              .then(() => {
                this.$router.push({ path: '/clients' })
              })
        }
      },
    },
    computed: {
      ...mapState({
        isLoading: state => state.reception.isLoading,
        saleInfo: state => state.sale.saleInfo,
        saleHistory: state => state.sale.saleHistory,
        validationErrors: state => state.reception.validationErrors,
      })
    },
    mounted() {
      //this.client !== undefined ? setItem('sale-client',this.client) : this.client = getItem('sale-client');

      let buyid = null

      if(this.buy_id){
        buyid = this.buy_id
        setItem('buy-history-id',this.buy_id)
      }

      if(getItem('buy-history-id')){
        buyid = getItem('buy-history-id')
      }

      this.fetchFeed(buyid)
    },
    watch: {
      searchClient() {
        let data = this.searchClient
        this.$store.dispatch(receptionActionTypes.searchClient, { data })
      }
    }
  }
  </script>
  
  <style scoped>
  .new-client {
    border-top: 1px solid #E0E0E0;
    margin: 0 16px 20px 16px;
    padding-top: 20px;
  }
  .new-client > span {
    margin-top: 20px;
    font-family: 'Circe';
    font-style: normal;
    font-weight: 700;
    font-size: 16px;
    line-height: 24px;
    color: #629F33;
    cursor: pointer;
  }
  .payment-text {
    font-family: 'Circe';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
  }
  .no-data-text {
    font-family: 'Circe';
    font-style: normal;
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    color: #767676;
    padding-left: 16px;
    padding-bottom: 16px;
  }
  .custom__text-field {
    font-size: 12px;
    font-weight: normal;
    padding: 20px 16px 16px 16px;
  }
  .custom__select {
    width: 330px;
  }
  .custom__select.v-select--is-menu-active {
    outline: 4px solid #E0ECD6;
  }
  .search-service.v-input--is-focused {
    outline: 4px solid #E0ECD6;
  }
  </style>